import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="treegrid--cell"
export default class TreegridCellController extends Controller {
	connect() {
		this.element.setAttribute("tabindex", "-1")

		this.element.addEventListener("keydown", this.onKeyDown)
	}

	disconnect() {
		this.element.removeEventListener("keydown", this.onKeyDown)
	}

	/** @param {KeyboardEvent} event */
	onKeyDown = (event) => {
		if (!this.isFocused) return

		switch (event.key) {
			case "ArrowRight": {
				if (this.next) {
					this.next.focus()
					break
				}
				return
			}
			case "ArrowLeft": {
				if (this.isFirst) {
					this.row.focus()
					break
				}

				if (this.prev) {
					this.prev.focus()
					break
				}
				return
			}
			case "ArrowDown": {
				if (this.lower) {
					this.lower.focus()
					break
				}
				return
			}
			case "ArrowUp": {
				if (this.upper) {
					this.upper.focus()
					break
				}
				return
			}
			case "Home": {
				if (event.ctrlKey && this.top) {
					this.top.focus()
					break
				}

				if (this.first) {
					this.first.focus()
					break
				}
				return
			}
			case "End": {
				if (event.ctrlKey && this.bottom) {
					this.bottom.focus()
					break
				}

				if (this.last) {
					this.last.focus()
					break
				}
				return
			}
			case "Enter": {
				if (this.isFirst && this.row.isExpandable) {
					this.row.isExpanded ? this.row.collapse() : this.row.expand()
					break
				}
				return
			}
			default: return
		}

		event.preventDefault()
		event.stopPropagation()
	}

	get index() {
		return this.row.cells.indexOf(this)
	}

	get isFocused() {
		return this.element == document.activeElement
	}

	get isFirst() {
		return !this.element.previousElementSibling
	}

	/** @returns {import("./row_controller").default} */
	get row() {
		return this.application.getControllerForElementAndIdentifier(
			this.element.closest(`[data-controller="treegrid--row"]`), "treegrid--row"
		)
	}

	/** @returns {TreegridCellController|import("./atom_controller").default} */
	get first() {
		const cell = this.row.firstCell

		return cell?.firstAtom ?? cell
	}

	/** @returns {TreegridCellController|import("./atom_controller").default} */
	get last() {
		const cell = this.row.lastCell

		return cell?.lastAtom ?? cell
	}

	/** @returns {TreegridCellController|import("./atom_controller").default} */
	get next() {
		const cell = this.row.cells[this.index + 1]

		return cell?.firstAtom ?? cell
	}

	/** @returns {TreegridCellController|import("./atom_controller").default} */
	get prev() {
		const cell = this.row.cells[this.index - 1]

		return cell?.lastAtom ?? cell
	}

	get lower() {
		return this.row.next?.cells[this.index]
	}

	get upper() {
		return this.row.prev?.cells[this.index]
	}

	get top() {
		return this.row.first?.cells[this.index]
	}

	get bottom() {
		return this.row.last?.cells[this.index]
	}

	/** @returns {import("./atom_controller").default[]}*/
	get atoms() {
		return Array.from(this.element.querySelectorAll(
			`[data-controller="treegrid--atom"]:not([hidden]):not([disabled])`
		)).map(element => this.application.getControllerForElementAndIdentifier(
			element, "treegrid--atom"
		))
	}

	get firstAtom() {
		return this.atoms[0]
	}

	get lastAtom() {
		const atoms = this.atoms

		return atoms[atoms.length - 1]
	}

	focus() {
		this.element.focus()
	}
}
